<template>
    <div class="product-option-input">
        <div v-if="productOption.type === OptionType.CHECKBOX" class="product-option-checkbox">
            <checkbox
                :label-left="true"
                :label="productOption.label + ((productOption.price) ? ` (${parsePrice(productOption.price)} extra)` : '')"
                @change="setValue(($event) ? 'true' : 'false')"
                :disabled="!(productOption.value == 'true' || productOption.value == 'yes') && isStepFull"
                :checked="(productOption.value == 'true' || productOption.value == 'yes') ? true : false"
            ></checkbox>
        </div>
        <div v-else-if="productOption.type === OptionType.RADIO">
            <p class="semi-bold option-title">{{ productOption.label }}</p>
            <div v-for="(valueLabel, i) in radioOptions" :key="valueLabel.value" :dusk="'option-item-' + i" class="align-middle product-option-radio grid-x" @click="setValue(valueLabel.value)">
                <div class="cell auto label-text">
                    {{ valueLabel.label }}
                </div>
                <div class="cell shrink text-center" style="margin-right:-10px">
                    <checkbox @change="($event) ? setValue(valueLabel.value) : null" :radio="true" :checked="valueLabel.value == productOption.value"></checkbox>
                </div>
            </div>
        </div>
        <div v-else-if="productOption.type === OptionType.TEXT" class="product-option-text">
            <p class="option-title">{{ productOption.label }}</p>
            <text-input
                :textarea="true"
                :value="productOption.value"
                @change="setValue($event)"
            ></text-input>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ProductOption, { OptionType } from '@/models/product-option';
import ProductCustomizerModule from '@/stores/modules/product-customizer';
import { getModule } from 'vuex-module-decorators';
import Checkbox from '@/components/common/ui/Checkbox.vue';
import TextInput from '@/components/common/forms/TextInput.vue';
import { printPrice } from '@/utils/utilities';
import Step from '@/models/step';

@Component({
    components: { Checkbox, TextInput }
})
export default class ProductOptionInput extends Vue
{
    @Prop(Object) readonly productOption!: ProductOption;
    @Prop(Object) readonly step!: Step;

    productCustomizerModule!: ProductCustomizerModule;

    created() {
        this.productCustomizerModule = getModule(ProductCustomizerModule, this.$store);
    }

    setValue(value: string) {
        const productOption = new ProductOption(this.productOption);
        productOption.value = value;
        this.productCustomizerModule.toggleProductOption([this.step, productOption]);
        this.productCustomizerModule.setDirty(true);
    }

    get radioOptions() {
        if (this.productOption.type === OptionType.RADIO) {
           return new ProductOption(this.productOption).radioOptions;
        }
        return [];
    }

    get isStepFull() {
        return this.step.max_items > 0 && this.productCustomizerModule.stepProductOptionsCount(this.step) === this.step.max_items;
    }

    get OptionType() {
        return OptionType;
    }

    get parsePrice() {
        return (price: number) => printPrice(price);
    }
}
</script>
<style lang="scss" scoped>

.product-option-checkbox, .product-option-input {
    padding: 6px 0;
}

.product-option-radio {
    padding: 10px 0;
}

.product-option-radio, .product-option-checkbox {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.product-option-radio {
    cursor: pointer;
}

.option-title, .radio-label {
    padding: 0 25px;
}

.radio-label, ::v-deep .label-text {
    color: var(--customizer-option-color);

    &.selected {
        font-weight: 600;
        color: var(--customizer-option-selected-color);
    }
    &.disabled {
        color: var(--customizer-option-disabled-color);
    }
}

.option-title {
    margin-bottom: 5px;
}

::v-deep .label-text {
    padding-left: 25px !important;
}

::v-deep .checkmark {
    margin-right: 18px !important;
}

</style>
